(function(scope) {
    scope.EmbedSVG = function(svgEl) {
        this.init = function(svgEl) {
            // console.log ("EmbedSVG", svgEl);
            /*start from: http://stackoverflow.com/questions/24933430/img-src-svg-changing-the-fill-color */
            /*
             * Replace all SVG images with inline SVGs
             */
            // jQuery('img.svg').each(function(){
            var $img = jQuery(svgEl);
            if ($img.hasClass ("embed-svg-done")) return;
            $img.addClass ("embed-svg-done");
            var imgID = $img.attr('id');
            var imgClass = $img.attr('class');
            var imgURL = $img.attr('src');
            if (!imgURL) imgURL = $img.css("background-image");
            var imgFrom = imgURL;
            var i = imgURL.indexOf("url(\"");
            if (i == 0) {
                imgURL = imgURL.split("url(\"").join("");
                imgURL = imgURL.substring(0, imgURL.length - 2);
            }
            i = imgURL.indexOf("url(");
            if (i == 0) {
                imgURL = imgURL.split("url(").join("");
                imgURL = imgURL.substring(0, imgURL.length - 1);
            }
            if (!imgURL || imgURL == "none") return;
            jQuery.get(imgURL, function(data) {
                // Get the SVG tag, ignore the rest
                var $svg = jQuery(data).find('svg');
                // Replace image with new SVG
                // console.log ("EmbedSVG", $img, "with", $svg);
                var mode
                if ($img.is(".embed-svg-replace")) mode = 1;
                else if ($img.is(".embed-svg-insert")) mode = 2;
                else if ($img.is(".embed-svg-prepend")) mode = 3;
                else mode = 2;
                if (mode == 1) {
                    // Add replaced image's ID to the new SVG
                    if (typeof imgID !== 'undefined') {
                        $svg = $svg.attr('id', imgID);
                    }
                    // Add replaced image's classes to the new SVG
                    if (typeof imgClass !== 'undefined') {
                        $svg = $svg.attr('class', imgClass + ' replaced-svg');
                    }
                    // Remove any invalid XML tags as per http://validator.w3.org
                    $svg = $svg.removeAttr('xmlns:a');
                    // Check if the viewport is set, if the viewport is not set the SVG wont't scale.
                    if (!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
                        $svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
                    }
                    $svg.style("background-image", "none", "important");
                    $img.replaceWith($svg);
                } else if (mode == 2 || mode == 3) {
                    //mode insert
                    $img.css({
                        backgroundImage: ""
                    });
                    var pos = $img.css("position");
                    if (pos == "static") {
                        $img.css({
                            position: "relative"
                        });
                    }
                    // $($svg).css ({
                    // 	width: "inherit",
                    // 	height: "inherit",
                    // 	// position: "absolute",
                    // 	// left: "0",
                    // 	// top: "0"
                    // });
                    if (mode == 2) $($svg).appendTo($img);
                    else {
                        $($svg).prependTo($img);
                    }
                    $img.style("background-image", "none", "important");
                }
                if ($("html").is(".is-ie")) {
                    var origW = parseFloat($svg.attr("width"));
                    var origH = parseFloat($svg.attr("height"));
                    var newW = $svg.width();
                    var newH = $svg.height();
                    // console.log ("");
                    // console.log (imgURL);
                    // console.log (origW, origH, newW, newH);		        	
                    // console.log ("");
                    var scale = newH / origH;
                    var scaledW = scale * origW;
                    $svg.attr("width", scaledW + "px");
                }
                $svg.removeClass("embed-svg-replace");
                $img.removeClass("embed-svg-insert");
                $img.removeClass("embed-svg-prepend");
            }, 'xml');
            // });
            /*end from: http://stackoverflow.com/questions/24933430/img-src-svg-changing-the-fill-color */
        };
        this.init(svgEl);
    };
})(window);
